var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
var Icon = styled.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n"], ["\n    color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colorNavIcon || '#fff';
});
export var InvertInfoIconSvg = function () { return (React.createElement(Icon, { viewBox: "0 0 32 32" },
    React.createElement("path", { fill: "currentColor", d: "M14.842,8.9q0-1.327,1.172-1.328a1.116,1.116,0,0,1,.874.342A1.428,1.428,0,0,1,17.2,8.9a1.4,1.4,0,0,1-.312.972,1.112,1.112,0,0,1-.869.347,1.187,1.187,0,0,1-.84-.308A1.327,1.327,0,0,1,14.842,8.9Z" }),
    React.createElement("circle", { fill: "none", cx: "16", cy: "16", r: "16" }),
    React.createElement("circle", { fill: "none", stroke: "currentColor", cx: "16", cy: "16", r: "15.5" }),
    React.createElement("rect", { fill: "currentColor", x: "15", y: "13", width: "2", height: "11" }))); };
var templateObject_1;
//# sourceMappingURL=InvertInfoIconSvg.js.map